// Visible, branded fallback shown only after the single guarded auto-reload has
// already run and a lazy chunk STILL fails to load. Never left as a silent
// blank #root. Styling uses the brand tokens from index.css (inline styles are
// permitted by the CSP `style-src 'unsafe-inline'`).

export interface ChunkLoadErrorProps {
  /** Hard-reload the tab to re-fetch the current index + chunks. */
  onReload: () => void
}

export default function ChunkLoadError({ onReload }: ChunkLoadErrorProps) {
  return (
    <main
      role="alert"
      data-testid="chunk-load-error"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        height: '100%',
        width: '100%',
        padding: 32,
        textAlign: 'center',
        background: 'var(--bg-primary, #121212)',
        color: 'var(--text-primary, #E8E6DF)',
        fontFamily: "'Satoshi', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <h1 style={{ margin: 0, fontSize: 20, fontWeight: 500 }}>Couldn&rsquo;t load the app</h1>
      <p style={{ margin: 0, maxWidth: 420, color: 'var(--text-secondary, #9C9A92)', lineHeight: 1.5 }}>
        A newer version is being deployed. Please refresh to load the latest.
      </p>
      <button
        type="button"
        data-testid="chunk-load-reload"
        onClick={onReload}
        style={{
          marginTop: 8,
          padding: '10px 20px',
          fontSize: 14,
          fontWeight: 500,
          cursor: 'pointer',
          borderRadius: 8,
          border: 'none',
          color: 'var(--text-inverse, #121212)',
          background: 'var(--brand-primary)',
        }}
      >
        Reload
      </button>
    </main>
  )
}
